import React, { Component } from "react";
import BsySelect from "../../BsySelect";
import "./index.css";

export default class FlowSwitchMenu extends Component {
  static defaultProps = {
    dockCorps: [],
    flowActive: "internalFlow",
    corpId: "",
    dockcount: 0,
    todocount: 0,
    corp_count: {},
    default_corp: "",
  };
  constructor(props) {
    super(props);
    this.state = {
      flowActive: props.flowActive,
      flowMenu: [
        {
          name: "organization.internal.flow",
          value: "internalFlow",
          num: props.todocount,
        },
        {
          name: "organization.external.flow",
          value: "externalFlow",
          num: props.dockcount,
        },
      ],
      dockCorps: props.dockCorp,
      corpId: props.corpId,
      corp_count: props.corp_count,
      default_corp: props.default_corp,
    };
  }

  switchFlowMenu = (v) => {
    this.setState({ flowActive: v }, () => {
      this.props.switchFlowMenu && this.props.switchFlowMenu(v);
    });
  };
  render() {
    const { flowActive, flowMenu, dockCorps, corpId, corp_count } = this.state;
    const corpList = dockCorps.map((res) => {
      return {
        text:
          res.name +
          (corp_count[res._id] || corp_count[res._id] === 0
            ? "(" + corp_count[res._id] + ")"
            : ""),
        value: res._id,
      };
    });
    return (
      <div className="flow-switch-menu">
        {flowMenu.map((res) => {
          if (res.value === "externalFlow") {
            if (corpList.length > 0) {
              return (
                <div>
                  <div
                    className={`flow-item ${
                      res.value === flowActive ? "active" : ""
                    }`}
                    onClick={() => {
                      this.switchFlowMenu(res.value);
                    }}
                  >
                    <div className="item-name">{React.language(res.name)}</div>
                    {res.num > 0 && <div className="item-tip"></div>}
                  </div>
                  {flowActive === "externalFlow" && (
                    <BsySelect
                      value={corpId}
                      items={corpList}
                      minWidth={200}
                      allowBlank={false}
                      customCls={"province"}
                      onStopEdit={(e1) => {
                        this.setState({ corpId: e1 }, () => {
                          this.props.onSwitchCorp &&
                            this.props.onSwitchCorp(e1);
                        });
                      }}
                    />
                  )}
                </div>
              );
            }
            return "";
          }

          return (
            ((res.value === "externalFlow" && corpList.length > 0) ||
              res.value === "internalFlow") && (
              <div
                className={`flow-item ${
                  res.value === flowActive ? "active" : ""
                }`}
                onClick={() => {
                  this.switchFlowMenu(res.value);
                }}
              >
                <div className="item-name">{React.language(res.name)}</div>
                {res.num > 0 && <div className="item-tip"></div>}
              </div>
            )
          );
        })}
      </div>
    );
  }
}
